import { Select } from "antd";
import { FC } from "react";

const SelectApiField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="yassocial" >یاس سوشیال</Select.Option>
      <Select.Option key="sharpsmm" >شارپ سوشیال</Select.Option>
    </Select>
  )
}

export default SelectApiField
